module.exports = "<nv-react-component component=\"LearnerEnrollmentModal\"></nv-react-component>";